import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '../use-api';

import type { IAdherenceSettingQueueLimitUpdate } from 'infrastructure/interfaces';

const api = `core-2/adherence-settings/queue-limits/bulk`;

interface IProps {
  updates: IAdherenceSettingQueueLimitUpdate[];
}

export const useBulkUpdateQueueLimits = () => {
  const { updateData } = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (dataProps: IProps) => updateData(api, dataProps),
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetQueueLimits']);
    },
  });

  return {
    mutateAsync,
    isLoading,
  };
};
